import "core-js/modules/es.array.map";
import getNavBarSection from './get-nav-bar-section';
import getClassicLink from './get-classic-link';
import NavigationBarRecord from '../../../../../records/NavigationBarRecord';
import NavigationItemRecord from '../../../../../records/NavigationItemRecord';
export default function mapMainSectionLinks(links) {
  return links.map(function (mainSectionItem) {
    var mainSectionLink = getClassicLink(mainSectionItem);
    var linkBarItem = getNavBarSection(mainSectionItem);
    linkBarItem.subMenuLinks = [[{
      link: new NavigationItemRecord(mainSectionLink)
    }]];
    return new NavigationBarRecord(linkBarItem);
  });
}